import { render } from "./addModuleContent.vue?vue&type=template&id=436f7c18"
import script from "./addModuleContent.vue?vue&type=script&lang=js"
export * from "./addModuleContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__